// Instance
import AuthAPI from '@/app/apis/auth/auth-api.js';

// Endpoints
import { AUTH_PUBLIC, AUTH_ENDPOINTS_PUBLIC } from '@/app/apis/auth/_connection/auth-connection-api-public.js';

class AuthHealthCheckAPI extends AuthAPI {
    async getHealthCheck() {
		return AUTH_PUBLIC.get(AUTH_ENDPOINTS_PUBLIC.GET_HEALTH_CHECK);
    }
}
  
export default new AuthHealthCheckAPI();
  